<template>
    <div class="dropPaneButton" ref="wrap">
        <icon-button :icon="icon" :size="size" ref="showPane" @click="doClick" :tabindex="tabindex"
                :title="title" :aria="aria" :disabled="disabled" class="dropButton">
            <template>
                <slot name="icon"></slot>
            </template>
        </icon-button>
        <drop-pane v-if="showed" :style="`top:${btnHeight}px`"
                v-click-outside="{ exclude: ['showPane'], handler: 'hide'}"
                :panename="panename" :tabindex="panetabindex"
                @hide="hide" @escape="$emit('escape')">
            <slot>btn nothing</slot>
        </drop-pane>
    </div>
</template>

<script>
import DropPane from '@/components/dropPane';
import IconButton from '@/components/iconButton';

export default {
  name: 'DropPaneButton',
  components: { DropPane, IconButton },
  data: function() {
    return {
      showed: false,
      refocusComponent: null
    };
  },
  props: {
    icon: {
      type: [ String, Array ],
      required: true
    },
    tabindex: {
      type: [ Number, String ],
      default: 0
    },
    panetabindex: {
      type: Number,
      default: 0
    },
    size: {
      type: String,
      default: '1x'
    },
    title: String,
    aria: String,
    disabled: Boolean,
    // Array of {text:, value:, disabled: <bool>}
    options: Array,
    panename: {
      type: String,
      required: true
    },
    triggerHide: Boolean
  },
  watch: {
    triggerHide(newVal) {
      if (newVal) {
        this.hide();
      }
    }
  },
  methods: {
    show() {
      this.$emit('beforeShow');
      this.showed = true;
      this.$nextTick(() => this.$emit('show'));
    },
    hide() {
      this.showed = false;
      this.$emit('hide');
      if (this.refocusComponent) {
        this.refocusComponent.reFocus();
        this.refocusComponent = null;
      }
    },
    doClick() {
      this.toggle();
    },
    toggle() {
      this.showed ? this.hide() : this.show();
    },
    onToolbarAction(action, tb) {
      if (!this.showed && ((action === ' ') || (action === 'Enter'))) {
        this.toggle();
        if (this.showed) {
          this.refocusComponent = tb;
        }
      } else if ((action === 'hide') && (this.showed)) {
        this.hide();
      }
    }
  },
  computed: {
    btnHeight() {
      return this.$refs.wrap.offsetHeight;
    }
  }
};
</script>

<style scoped>
    .dropPaneButton {
        position:relative;
        display: inline-block;
    }
    .dropButton {
        margin-left: 0;
    }

</style>
